import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { lazy as loadable } from '@loadable/component'

import { wrapSuspenseComponent } from '@newComponents/SuspenseWrapper'

import { DocsSection } from '../shared/DocsSection'

const Overview = wrapSuspenseComponent(loadable(() => import('./Overview')))
const CommandMenu = wrapSuspenseComponent(loadable(() => import('./CommandMenu')))
const Search = wrapSuspenseComponent(loadable(() => import('./Search')))
const Navigation = wrapSuspenseComponent(loadable(() => import('./Navigation')))

const GettingStartedSection = () => (
  <DocsSection section='getting-started'>
    <Routes>
      <Route index element={<Overview />} />
      <Route path='overview' element={<Overview />} />
      <Route path='command-menu' element={<CommandMenu />} />
      <Route path='search' element={<Search />} />
      <Route path='navigation' element={<Navigation />} />
    </Routes>
  </DocsSection>
)

export default GettingStartedSection
